import { render, staticRenderFns } from "./InvoiceUpdateMetadataDialog.vue?vue&type=template&id=8c36005c&scoped=true"
import script from "./InvoiceUpdateMetadataDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceUpdateMetadataDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceUpdateMetadataDialog.vue?vue&type=style&index=0&id=8c36005c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c36005c",
  null
  
)

export default component.exports